import {Map} from 'immutable';

import * as PasswordRecoveryActions from 'actions/PasswordRecovery';
import * as PasswordRecoveryStates from 'constants/PasswordRecoveryState';

const initialState = Map({
    isOngoing: false,
    state: undefined,
    email: undefined,
    phone: undefined,
    errorCode: undefined,
    createPasswordErrorCode: undefined,
    createPasswordState: undefined
});

export default function (state, action) {
    if (state === undefined) {
        return initialState;
    }

    switch (action.type) {
        case PasswordRecoveryActions.BEGIN_PASSWORD_RECOVERY:
            state = state.set('state', PasswordRecoveryStates.INIT);
            state = state.set('isOngoing', true);
            break;

        case PasswordRecoveryActions.CANCEL_PASSWORD_RECOVERY:
            state = initialState;
            break;

        case PasswordRecoveryActions.RECOVER_PASSWORD:
            state = state.set('state', PasswordRecoveryStates.REQUEST);
            break;

        case PasswordRecoveryActions.SUCCESS_RECOVER_PASSWORD:
            state = state.set('state', action.data.Error ? PasswordRecoveryStates.INIT : PasswordRecoveryStates.FINISH);
            state = state.set('email', action.data.Email);
            state = state.set('phone', action.data.Phone);
            state = state.set('errorCode', action.data.Error);
            break;

        case PasswordRecoveryActions.FAILURE_RECOVER_PASSWORD:
            state = state.set('state', PasswordRecoveryStates.FINISH);
            state = state.set('errorCode', 500);
            break;

        case PasswordRecoveryActions.SUCCESS_PHONE_RECOVER_PASSWORD:
            if (action.data.Error) {
                state = state.set('createPasswordErrorCode', action.data.Error);
            } else if (action.data.ResulState && action.data.ResulState !== 0) {
                state = state.set('createPasswordErrorCode', action.data.ResultState);
            } else if (action.data.ResultState === 0) {
                state = state.set('createPasswordState', 0);
                state = state.set('createPasswordErrorCode', undefined);
            }
            break;

        case PasswordRecoveryActions.FAILURE_PHONE_RECOVER_PASSWORD:
            state = state.set('createPasswordErrorCode', action.data.Error);
            break;
    }

    return state;
}



// WEBPACK FOOTER //
// ./js/sport-betting/reducers/passwordRecoveryReducer.js